import { useEffect } from 'react';
import { getChannel } from 'utils';

export default function usePageTitle(title?: string) {
  useEffect(() => {
    const { productName } = getChannel();
    document.title = title ? `${title} - ${productName}` : productName;
  }, [title]);
}
